var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAmexLogo = function SvgAmexLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.539,
    y: 0.208,
    width: 28.75,
    height: 19.583,
    rx: 2.292,
    fill: "#1F72CD",
    stroke: "#D8D8D8",
    strokeWidth: 0.417
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56 7.083l-2.73 6.039h3.268l.405-.963h.925l.405.963h3.596v-.735l.32.735h1.86l.321-.75v.75h7.479l.909-.938.851.938 3.842.008-2.738-3.01 2.738-3.037h-3.782l-.885.92-.825-.92h-8.135l-.7 1.559-.714-1.559H8.71v.71l-.363-.71H5.56zm.631.858h1.593l1.81 4.095V7.94h1.744l1.398 2.936 1.289-2.936h1.736v4.333h-1.057l-.008-3.396-1.54 3.396h-.945l-1.548-3.396v3.396H8.49l-.412-.972H5.853l-.411.971H4.278L6.19 7.941zm14.83 0h-4.294v4.33h4.228l1.363-1.435 1.313 1.435h1.373l-1.995-2.153 1.995-2.177h-1.313l-1.356 1.418-1.313-1.418zm-14.055.733l-.734 1.73h1.466l-.732-1.73zm10.822.955v-.792h2.68l1.17 1.265-1.222 1.272h-2.628v-.864h2.343V9.63h-2.343z",
    fill: "#fff"
  })));
};
export default SvgAmexLogo;